// @ts-strict-ignore
import invariant from 'invariant';
import smoothscroll from 'smoothscroll-polyfill';

import { isBrowser } from 'utils/browser';
import { matchSize } from 'utils/responsive';

// Kick off the polyfill
if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

// Adapted from https://plainjs.com/javascript/styles/get-the-position-of-an-element-relative-to-the-document-24/
function calculateOffset(el, container) {
  const rect = el.getBoundingClientRect();
  invariant(document.documentElement, 'document.documentElement not defined');
  const scrollLeft = container
    ? container.scrollLeft
    : window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = container
    ? container.scrollTop
    : window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft,
  };
}

// Scroll element into view. Padding is space above the element
export const scrollIntoView = (
  element?: Element | null | undefined,
  {
    padding,
    noTransition,
    container,
  }: {
    padding?: number;
    noTransition?: boolean;
    container?: string;
  } = {}
) => {
  let prefersReducedMotion = false;

  if (isBrowser()) {
    // Don't use smooth scrolling when the user prefers reduced motion
    prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
  }
  const containerEl = container ? document.getElementById(container) : null;
  const offset = element
    ? calculateOffset(element, containerEl)
    : {
        top: 0,
      };
  let offsetAboveElement = padding || 32;

  if (
    matchSize({
      xs: true,
      sm: true,
      md: true,
    })
  ) {
    // compensate for the sticky page header on mobile
    offsetAboveElement += 66;
  } else if (
    matchSize({
      lg: true,
      xl: true,
    }) &&
    offset.top > 0
  ) {
    offsetAboveElement += 96;
  }

  const scrollEl = containerEl || window;
  scrollEl.scrollTo({
    top: offset.top - offsetAboveElement,
    left: 0,
    behavior: noTransition || prefersReducedMotion ? 'auto' : 'smooth',
  });
};

export const scrollToHash = (
  hash?: string,
  options?: {
    padding?: number;
    noTransition?: boolean;
    container?: string;
  }
) => {
  if (hash && hash.length > 0) {
    const id = hash.replace('#', '');
    const el = document.getElementById(id);

    if (el) {
      scrollIntoView(el, options);
    }
  }
};
